import {Card, styled} from '@mui/material'

export const SystemCard = styled(Card)((props) => ({
  minWidth: '70%',
  maxWidth: '80%',
  borderRadius: 20,
  '.MuiCardHeader-root': {
    background: props.theme.palette.grey[50]
  }
}))
